import CheckoutPriceBox from './CheckoutPriceBox';

export default CheckoutPriceBox;
